import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export enum IconSize {
  Default = 'default',
  Small = 'iconS',
  Medium = 'iconM',
  Large = 'iconL',
  ExtraLarge = 'iconXL',
  ExtraExtraLarge = 'iconXXL'
}

@Component({
  selector: 'pcs-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent implements OnChanges {
  @Input() icon: string;
  @Input() styles = '';
  @Input() size: IconSize = IconSize.Default;

  materialIcon = '';
  iconClasses = null;

  ngOnChanges({icon}: SimpleChanges): void {
    if (icon) {
      this.materialIcon = this.isPcsIcon() ? '' : this.icon;
    }
    this.iconClasses = this.calculateIconClasses();
  }

  private calculateIconClasses() {
    return {
      [`pcs-icon ${this.icon}`]: this.isPcsIcon(),
      'material-icons': !this.isPcsIcon(),
      [`${this.styles}`]: true,
      'icon-sm': this.isOfSize(IconSize.Small),
      'icon-m': this.isOfSize(IconSize.Medium),
      'icon-l': this.isOfSize(IconSize.Large),
      'icon-xl': this.isOfSize(IconSize.ExtraLarge),
      'icon-xxl': this.isOfSize(IconSize.ExtraExtraLarge)
    };
  }

  private isOfSize(size: IconSize) {
    return this.size === size;
  }

  private isPcsIcon() {
    return this.icon && this.icon.startsWith('pcs-icon');
  }
}
